import { get, post } from "aws-amplify/api";

export interface MarketingFeature {
  name: string;
}

export interface StripeProduct {
  id: string;
  active: boolean;
  name: string;
  description: string | null;
  metadata: Record<string, string>;
  default_price: string | null;
  marketing_features: MarketingFeature[];
  prices: StripePrice[];
}

export interface StripePrice {
  id: string;
  unit_amount: number | null;
  currency: string;
  recurring: {
    interval: string;
    interval_count: number;
  } | null;
  nickname: string | null;
  type: string;
}

export interface CheckoutSessionResponse {
  sessionId: string;
  url: string;
}

export const fetchStripeProducts = async (): Promise<StripeProduct[]> => {
  try {
    const restOperation = get({
      apiName: "stripesystemapi",
      path: "/stripe/products",
    });
    
    const operationResponse = await restOperation.response;
    const products = await operationResponse.body.json();
    return products as unknown as StripeProduct[];
  } catch (error) {
    console.error("Error fetching Stripe products:", error);
    throw error;
  }
};

export const createCheckoutSession = async (params: {
  priceId: string;
  userId?: string;
  userEmail?: string;
  successUrl?: string;
  cancelUrl?: string;
}): Promise<CheckoutSessionResponse> => {
  try {
    const restOperation = post({
      apiName: "stripesystemapi",
      path: "/stripe/create-checkout-session",
      options: {
        body: params
      }
    });
    
    const operationResponse = await restOperation.response;
    const session = await operationResponse.body.json();
    return session as unknown as CheckoutSessionResponse;
  } catch (error) {
    console.error("Error creating checkout session:", error);
    throw error;
  }
};